// extracted by mini-css-extract-plugin
export var container = "_22-0";
export var disabled = "_22-4";
export var fullWidth = "_22-3";
export var lined = "_22-1";
export var selected = "_22-5";
export var tab = "_22-2";